// extracted by mini-css-extract-plugin
module.exports = {"form":"form-7Ld7m","root":"root-F9OE5","label":"label-2IPVs"};